import { convertDate, roundToThreeDecimals } from '../../../helpers/modules';
import React, { useEffect, useState } from 'react';

const PrintToPdf = ({ componentRef, deliveryDetails, adminCompany }) => {
	const [countryMap, setCountryMap] = useState({});
	const [countryNames, setCountryNames] = useState({});

	useEffect(() => {
		fetch('https://cdn.jsdelivr.net/npm/world-countries@4/dist/countries.json')
			.then((res) => res.json())
			.then((data) => {
				const map = {};
				const names = {};
				data.forEach((c) => {
					if (c.cca3 && c.cca2) {
						map[c.cca3] = c.cca2.toLowerCase();
						names[c.cca3] = c.name.common;
					}
				});
				setCountryMap(map);
				setCountryNames(names);
			})
			.catch((err) => console.error('Failed to fetch country codes:', err));
	}, []);

	const getFlagUrl = (cca3) => {
		if (!cca3 || !countryMap[cca3]) return null;
		return `https://hatscripts.github.io/circle-flags/flags/${countryMap[cca3]}.svg`;
	};

	const getCountryName = (cca3) => {
		return countryNames[cca3] || cca3;
	};

	if (!deliveryDetails || Object.keys(deliveryDetails).length === 0) {
		return null;
	}

	const { delivery, list, totals, companyInfo, clientCompany } = deliveryDetails;
	const itemsPerPage = [8, 15];

	const shopCountry = delivery?.order_id?.shopInfo?.country;

	const hasCompany = () => {
		return clientCompany ? true : false;
	};

	const calculatePlatformFee = () => {
		if (!hasCompany()) return 0;
		const totalTTC = totals?.total_TTC || 0;
		return totalTTC * 0.1;
	};

	const platformFee = calculatePlatformFee();

	const adminLogo = adminCompany?.image?.secure_url || null;

	const renderTableRows = (start, end) => {
		return list?.slice(start, end).map((el, index) => (
			<tr className='elements' key={index}>
				<td>{el?.reference ?? '-'}</td>
				<td>{el?.refranceCTL ?? '-'}</td>
				<td>{el?.designation ?? '-'}</td>
				<td>{el?.quantity ?? '-'}</td>
				<td>{roundToThreeDecimals(el?.price || 0)} DT</td>
				<td>{el?.tva || 0}%</td>
				<td>{roundToThreeDecimals(el?.total || 0)} DT</td>
			</tr>
		));
	};

	const renderTable = (start, end) => {
		return (
			<div key={start} className='page-content'>
				<div className='devis-table'>
					<table className='offres'>
						<thead>
							<tr id='titres'>
								<th>RÉFÉRENCE</th>
								<th>CODE E.A.N</th>
								<th>DÉSIGNATION</th>
								<th>QTÉ</th>
								<th>PRIX UNIT H.T</th>
								<th>TVA</th>
								<th>MONTANT H.T</th>
							</tr>
						</thead>
						<tbody>{renderTableRows(start, end)}</tbody>
					</table>
				</div>
			</div>
		);
	};

	const totalHT = totals?.total_HT || 0;
	const totalTVA = totals?.total_TVA || 0;
	const timbre = totals?.timbre || 0;
	const totalTTC = totals?.total_TTC || 0;

	return (
		<div className='delivery-pdf' ref={componentRef}>
			{adminLogo && (
				<div className='pdf-logo-container'>
					<img src={adminLogo} alt='Logo société' className='pdf-logo-img' />
				</div>
			)}

			<div className='devis'>
				<h4>BON DE LIVRAISON</h4>
				<div className='info'>
					<div>
						<label>Numéro:</label>
						<label>Date:</label>
						<label>Référence code client:</label>
					</div>
					<div>
						<span>{delivery?.reference ?? '-'}</span>
						<span>{delivery?.createdAt ? convertDate(delivery.createdAt, 'DD-MM-YYYY') : '-'}</span>
						<span>{delivery?.order_id?.clientInfo?.customs_code ?? '-'}</span>
					</div>
				</div>
			</div>
			<div className='general-info'>
				<div className='left'>
					<h2 className='infos-societe'>🛒 JEUN'ESS MARKET</h2>
					<div className='address'>
						<span>VTE EN GROS ART DE MENAGE</span>
					</div>
				</div>
				<div className='right'>
					<h3>{delivery?.order_id?.clientInfo?.company_name ?? ''}</h3>
					<p>{delivery?.order_id?.clientInfo?.client ?? ''}</p>
					<p>
						Matricule Fiscale:{' '}
						{delivery?.order_id?.clientInfo?.tax_registration_number
							? delivery.order_id.clientInfo.tax_registration_number
							: '-'}
					</p>{' '}
					<p>N° téléphone: {delivery?.order_id?.clientInfo?.phone ?? ''}</p>
					<span>{delivery?.order_id?.shopInfo?.address_number} </span>
					<span>{delivery?.order_id?.shopInfo?.street} </span>
					<span>{delivery?.order_id?.shopInfo?.ville} </span>
					<span>{delivery?.order_id?.shopInfo?.postal_code} </span>
					<span>{delivery?.order_id?.shopInfo?.region} </span>
					{shopCountry && (
						<div style={{ marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
							{getFlagUrl(shopCountry) && (
								<img
									src={getFlagUrl(shopCountry)}
									alt={getCountryName(shopCountry)}
									width='14'
									height='14'
									style={{ borderRadius: '50%' }}
								/>
							)}
							<span style={{ fontSize: '0.625rem', color: '#0f172a', fontWeight: 300 }}>
								{getCountryName(shopCountry)}
							</span>
						</div>
					)}
				</div>
			</div>

			<div
				className='platform-fee-print'
				style={{
					margin: '10px 0',
					padding: '10px',
					border: hasCompany() ? '2px solid #FFA000' : '2px solid #4CAF50',
					borderRadius: '5px',
					backgroundColor: hasCompany() ? '#FFF3CD' : '#E8F5E9',
				}}
			>
				<h3
					style={{
						margin: '0 0 5px 0',
						fontSize: '12px',
						color: hasCompany() ? '#856404' : '#2E7D32',
					}}
				>
					{hasCompany() ? '📢 Frais de Plateforme Marketing' : '✅ Frais de Plateforme Marketing'}
				</h3>
				{hasCompany() ? (
					<p style={{ margin: '0', fontSize: '10px', color: '#856404' }}>
						<strong>10% du montant total</strong> de cette livraison sera prélevé pour la plateforme
						afin de soutenir les objectifs marketing. Montant total :{' '}
						<strong>{roundToThreeDecimals(totalTTC)} DT</strong> → Frais de plateforme (10%) :{' '}
						<strong>{roundToThreeDecimals(platformFee)} DT</strong>
					</p>
				) : (
					<p style={{ margin: '0', fontSize: '10px', color: '#2E7D32' }}>
						Aucun frais de marketing n'est appliqué car le client n'est pas associé à une
						entreprise. Frais de plateforme : <strong>0 DT</strong>
					</p>
				)}
			</div>

			<div className='cher-client'>
				<p>
					Cher Client,
					<br />
					Nous avons bien reçu votre demande et nous vous en remercions.
					<br />
					Nous vous prions de trouver ci-dessous les détails de votre livraison.
				</p>
			</div>

			{renderTable(0, itemsPerPage[0])}
			{Array.from(
				{
					length: Math.ceil((list?.length - itemsPerPage[0]) / itemsPerPage[1]),
				},
				(_, index) =>
					renderTable(
						itemsPerPage[0] + index * itemsPerPage[1],
						itemsPerPage[0] + (index + 1) * itemsPerPage[1],
					),
			)}

			<div className='totals-section-print'>
				<div className='totals-box-print'>
					<div className='total-line-print'>
						<span>TOTAL H.T</span>
						<span>{roundToThreeDecimals(totalHT)} DT</span>
					</div>
					<div className='total-line-print'>
						<span>TVA</span>
						<span>{roundToThreeDecimals(totalTVA)} DT</span>
					</div>
					<div className='total-line-print'>
						<span>TIMBRE</span>
						<span>{roundToThreeDecimals(timbre)} DT</span>
					</div>
					<div className='total-line-print grand-total-print'>
						<span>TOTAL TTC</span>
						<span>{roundToThreeDecimals(totalTTC)} DT</span>
					</div>
					<div
						className='total-line-print'
						style={{ borderTop: '2px solid #FFA000', paddingTop: '10px', marginTop: '10px' }}
					>
						<span style={{ color: hasCompany() ? '#D32F2F' : '#4CAF50', fontWeight: 'bold' }}>
							FRAIS MARKETING (10%)
						</span>
						<span style={{ color: hasCompany() ? '#D32F2F' : '#4CAF50', fontWeight: 'bold' }}>
							{roundToThreeDecimals(platformFee)} DT
						</span>
					</div>
				</div>
			</div>

			<div className='footer'>
				<div className='left'>
					<ul>
						<li>
							<strong>{companyInfo?.name || '-'}</strong>
						</li>
						<li>Adresse: {companyInfo?.address || '-'}</li>
						<li>
							CODE TVA: <span>{companyInfo?.tva_code || '-'}</span>
						</li>
						<li>
							RC: <span>{companyInfo?.r_c || '-'}</span>
						</li>
						<li>
							Code en Douane: <span>{companyInfo?.customs_code || '-'}</span>
						</li>
					</ul>
				</div>
				<div className='left'>
					<ul>
						<li>
							Tél: <span>{companyInfo?.phone || '-'}</span>
						</li>
						<li>
							Fax: <span>{companyInfo?.fax || '-'}</span>
						</li>
						<li>
							Email: <span>{companyInfo?.email || '-'}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

export default PrintToPdf;
